import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'El combo se pagó solo con la primera puerta balcón que fabriqué.',
  author: 'Marcelo R.',
  location: 'Buenos Aires'
}, {
  quote: 'Por primera vez en mi vida terminé un trabajo sin perfiles quemados.',
  author: 'Jorge C.',
  location: 'Rosario'
}, {
  quote: 'Subí mis precios un 40% y cerré más trabajos que antes. Los scripts del Bono 2 son oro.',
  author: 'Sofía V.',
  location: 'Córdoba'
}, {
  quote: 'Llegué sin oficio. En 5 semanas fabriqué y vendí mi primera ventana Módena.',
  author: 'Rodrigo P.',
  location: 'Tucumán'
}];
export function TestimonialsSection() {
  return <section className="py-10 bg-darkgray text-white" data-id="element-321">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-322">
        <div className="text-center mb-8" data-id="element-323">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-2" data-id="element-324">
            LO QUE DICEN LOS QUE YA FABRICAN
          </h2>
          <div className="w-16 h-1 bg-gold mx-auto" data-id="element-325"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-4" data-id="element-326">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="bg-matte p-6 border-l-4 border-gold" data-id="element-327">
              <div className="flex mb-3" data-id="element-328">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-gold fill-gold" data-id="element-329" />)}
              </div>
              <p className="text-base italic text-gray-300 mb-4" data-id="element-330">"{t.quote}"</p>
              <div className="border-t border-silver/20 pt-3" data-id="element-331">
                <p className="font-bold text-white text-sm" data-id="element-332">{t.author}</p>
                <p className="text-xs text-silver" data-id="element-333">{t.location}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}